import { render, staticRenderFns } from "./PageParamsCover.vue?vue&type=template&id=6ba0a14e&scoped=true"
import script from "./PageParamsCover.vue?vue&type=script&lang=js"
export * from "./PageParamsCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba0a14e",
  null
  
)

export default component.exports